import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Head from 'next/head';

export default function Index() {
  const router = useRouter();
  
  return (
    <>
      <Head>
        <title>GC</title>
      </Head>
      <div>Who goes there</div>
    </>
  );
}
